import {useMemo, memo, FC, useCallback} from 'react';
import {Link, useHistory} from 'react-router-dom';
import EnsurePermission from '../../common/EnsurePermission';
import ListOptions from '../../common/ListOptions';
import permissionsInfo from '../../../constants/permissionsInfo';
import routes from '../routes';
import {getSurveyListDate} from '../helpers';
import {SurveyRowProps} from '../types';
import {Button} from '../../common/Button';
import DeleteIcon from '@mui/icons-material/Delete';

const SurveyRow: FC<SurveyRowProps> = ({
  survey: {
    surveyId, completed, dateCreated,
    patientFirstName, patientLastName, treatment
  },
  contentLength,
  openModal
}: SurveyRowProps) => {
  const history = useHistory();
  const formattedPatientName = `${patientLastName} ${patientFirstName.charAt(0)}.`;
  const deletionMessage =
    `Survey for patient "${formattedPatientName}" will be removed.`;

  const options = useMemo(() => {
    return {
      DELETE_SURVEY: {
        name: 'Delete',
        permission: permissionsInfo.surveys.delete,
        onClick: () => openModal({
          id: surveyId,
          contentLength,
          message: deletionMessage,
          patientName: formattedPatientName
        }),
        Icon: DeleteIcon
      }};
  }, [deletionMessage, surveyId, openModal]);

  const completeSurvey = useCallback(() => {
    history.push(routes.item(surveyId));
  }, [surveyId]);

  return (
    <tr className="row surveys" key={`${surveyId}`}>
      <td className="cell">
        <Link to={routes.item(surveyId)} className="link">
          {surveyId}
        </Link>
      </td>
      <td className="cell">{getSurveyListDate(dateCreated)}</td>
      <td className="cell">{formattedPatientName}</td>
      <td className="cell">{treatment?.displayName}</td>
      <td className="cell">
        {completed ? 'Yes' : (
          <EnsurePermission elementPermissions={[
            ...permissionsInfo.surveys.complete
          ]}>
            <Button onClick={completeSurvey} variant="text" label="Complete" size="small" />
          </EnsurePermission>
        )}
      </td>
      <EnsurePermission elementPermissions={[
        ...permissionsInfo.surveys.delete
      ]}>
        <td className="cell narrow-cell">
          <ListOptions options={options} />
        </td>
      </EnsurePermission>
    </tr>
  );
};

export default memo(SurveyRow);
